var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart',{attrs:{"options":_vm.options,"height":_vm.chartHeight,"on":_vm.events}})
}
var staticRenderFns = []

export { render, staticRenderFns }